module.exports = __webpack_public_path__ + "img/advantage-item-05.f4909648.png";